import { ArBitmapText, ArContainer, currencyService } from "@aceroll/core";
const config = {
    label: 'Total Win Text',
    bitmapFont: 'bitmap-win-line',
    style: 'totalWinLabel'
}
export default class TotalWin extends ArContainer {
    #text;

    constructor() {
        super('Total Win');
        this.#text = this.#createText(config);

        this.visible = false;
    }
    #createText(config) {
        const text = ArBitmapText.from(config.bitmapFont, '9999', config.label, config.style);
        text.setScalable(1000);
        text.anchor.set(0.5);
        return this.addChild(text);

    }
    show(value) {
        this.#text.text = currencyService.toMoney(value);
        this.visible = true;
    }
    hide() {
        this.visible = false;
    }
}
